import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  standalone: false,
  selector: 'wr-checkout-resident-dialog',
  templateUrl: './checkout-resident-dialog.component.html',
  styleUrls: ['./checkout-resident-dialog.component.scss'],
})
export class CheckoutResidentDialogComponent {
  @Input() customerNumber = '';
  @Input() startDate = '';

  endDate: Date | undefined = undefined;
  error: string | null = null;

  constructor(private readonly dialogRef: NbDialogRef<CheckoutResidentDialogComponent>) {}

  submit(): void {
    if (!this.endDate) {
      this.error = 'Bitte wählen Sie ein Auszugsdatum.';
      return;
    }
    const y = this.endDate.getFullYear();
    const m = String(this.endDate.getMonth() + 1).padStart(2, '0');
    const d = String(this.endDate.getDate()).padStart(2, '0');
    const endIso = `${y}-${m}-${d}`;
    if (this.startDate && endIso < this.startDate) {
      this.error = 'Das Auszugsdatum darf nicht vor dem Einzugsdatum liegen.';
      return;
    }
    this.dialogRef.close(endIso);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
